import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-50ef26f3"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main-content" }
const _hoisted_2 = { class: "bank_account" }
const _hoisted_3 = { class: "profile_container" }
const _hoisted_4 = { class: "title_box" }
const _hoisted_5 = { class: "mb-3" }
const _hoisted_6 = { class: "profile_main_container" }
const _hoisted_7 = { class: "profile_left_box" }

import CurrentUserResponse from "@/api/main/dataSource/api/aba/cabinet/web/models/CurrentUserResponse";
import ModelNaturalPerson from "@/api/main/dataSource/api/i-public-service/aba-finance/models/user/ModelNaturalPerson";
import GetNaturalPersonResponse from "@/api/main/services/NaturalPersonHome/models/response/GetNaturalPersonResponse";
import NaturalPersonModel from "@/views/models/NaturalPersonModel";
import { onMounted, Ref, ref } from "vue";

import TabModel from "../../models/TabModel";
import { AdapterProfileService } from "./adapter";
import { PersonModel } from '@/views/models';


export default /*#__PURE__*/_defineComponent({
  __name: 'profile-natural-page',
  setup(__props) {

const tabs = ref([]);
const currentTabId = ref(1);
let Person:PersonModel =null;
const srcQr = ref("");
const SelectImage = ref("");
const IsIdentified = ref(false);

const isShowTwoFactorWindow = ref(false);
const adapter = AdapterProfileService.getInstance();
let IsLoadPerson = false
onMounted(async () => {
	await getPerson();
	init();
	onChangeTab(1);

	// await setPerson();
	await CheckIdentified();
});
async function getPerson() {
		const resp = await adapter.getPerson();
		if (resp) {
			Person = resp;
			IsLoadPerson = true;
		}
	
	}
function init() {
	tabs.value = [
		new TabModel({
			Id: 1,
			Name: "PersonalInformation",
			Active: true,
		}),
		new TabModel({
			Id: 2,
			Name: "Identification",
			Active: false,
		}),
		new TabModel({
			Id: 3,
			Name: "Security",
			Active: false,
		}),
		// new TabModel({
		// 	Id: 4,
		// 	Name: "Language",
		// 	Active: false,
		// }),
		// new TabModel({
		// 	Id: 5,
		// 	Name: "Limits",
		// 	Active: false,
		// }),
	];
}

function changeLang() {
	init();
	tabs.value[0].Active = false;
	tabs.value[3].Active = true;
}

function curLang() {
	return this.$localization.currentLang;
}

function onChangeTab(id: number) {
	currentTabId.value = id;
}

async function GetInfo() {
	// const res = await adapter.getNaturalPerson();
}

// @Watch("$store.state.currentPersonProfile", { deep: true })
async function setPerson() {

	const res = await adapter.naturalPerson.value;

	if (!res.Name) {
		await adapter.GetNaturalPerson();
	}
	Person.value = adapter.convertModelNaturalPersonToNaturalPersonModel(res);
	// if (this.$store.state.currentPersonProfile) {
	// 	this.Person = this.adapter.toNaturalPerson(this.$store.state.currentPersonProfile);
	// }

	const user = localStorage.getItem("User");
	if (user) {
		const User = new CurrentUserResponse(JSON.parse(user));
		const adapter = AdapterProfileService.getInstance();
		const person = adapter.naturalPerson.value;
		Person.value = adapter.convertModelNaturalPersonToNaturalPersonModel(person);
	}
	// const res = await this.adapter.GetNaturalPerson();
	// if (res.IsSuccess) {
	// 	this.Person = res.Value;
	// }
}

async function CheckIdentified() {
	const res = await adapter.checkIdentified();
	IsIdentified.value = res;
}
function EnableAunth(src: string) {
	srcQr.value = src;
	isShowTwoFactorWindow.value = true;
}
// ShowImage(img: string) {
//   if (!img) this.SelectImage = "/files/";
//   this.SelectImage = img;
// }

return (_ctx: any,_cache: any) => {
  const _component_info_person = _resolveComponent("info-person")!
  const _component_identification_data = _resolveComponent("identification-data")!
  const _component_security = _resolveComponent("security")!
  const _component_language_tab = _resolveComponent("language-tab")!
  const _component_limits = _resolveComponent("limits")!
  const _component_ui_tab_profile = _resolveComponent("ui-tab-profile")!
  const _component_two_factor_authentication = _resolveComponent("two-factor-authentication")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("h2", _hoisted_5, _toDisplayString(_ctx.$localization.getTranslate("Profile")), 1),
            _createElementVNode("div", null, _toDisplayString(_unref(Person)?.Balance?.Number), 1)
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_component_ui_tab_profile, {
                tabs: tabs.value,
                onOnChangeTab: onChangeTab
              }, {
                "1": _withCtx(() => [
                  _createVNode(_component_info_person, { Person: _unref(Person) }, null, 8, ["Person"])
                ]),
                "2": _withCtx(() => [
                  _createVNode(_component_identification_data, { Person: _unref(Person) }, null, 8, ["Person"])
                ]),
                "3": _withCtx(() => [
                  _createVNode(_component_security, { onEnableAunth: EnableAunth })
                ]),
                "4": _withCtx(() => [
                  _createVNode(_component_language_tab, { onChangeLang: changeLang })
                ]),
                "5": _withCtx(() => [
                  _createVNode(_component_limits)
                ]),
                _: 1
              }, 8, ["tabs"])
            ])
          ])
        ])
      ])
    ]),
    _createVNode(_component_two_factor_authentication, {
      srcQr: srcQr.value,
      visible: isShowTwoFactorWindow.value,
      onClose: _cache[0] || (_cache[0] = ($event: any) => (isShowTwoFactorWindow.value = false))
    }, null, 8, ["srcQr", "visible"])
  ], 64))
}
}

})